import Image from 'next/image';
import { ICaseItem } from '@/utils/types/ICaseBattle';
import { rarityColor } from '@/utils/rarity';

interface Props {
    item: ICaseItem;
}

const CaseSkin = ({ item }: Props) => {
    const skin = item.item;
    const rarity = rarityColor(skin.colorHex);

    return (
        <div
            className="group relative rounded-fl-md p-2.5 pb-3 flex flex-col items-center gap-1.5 overflow-hidden transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_22px_-8px_var(--rarity)]"
            style={
                {
                    ['--rarity' as string]: rarity,
                    background: `linear-gradient(160deg, color-mix(in srgb, ${rarity} 16%, transparent), color-mix(in srgb, ${rarity} 4%, transparent))`,
                    border: `1px solid color-mix(in srgb, ${rarity} 26%, transparent)`,
                } as React.CSSProperties
            }
            title={skin.name}
        >
            <span
                className="font-chat-nick absolute top-2 left-2 z-[1] px-1.5 py-0.5 rounded text-[9.5px] font-extrabold tabular-nums tracking-[0.04em]"
                style={{
                    background: `color-mix(in srgb, ${rarity} 18%, rgba(0,0,0,0.4))`,
                    border: `1px solid color-mix(in srgb, ${rarity} 45%, transparent)`,
                    color: rarity,
                }}
            >
                {(item.probability * 100).toFixed(2)}%
            </span>
            <div className="relative w-[78px] h-[78px] mt-3.5 grid place-items-center">
                {skin.iconBackground && (
                    <Image
                        src={skin.iconBackground}
                        alt=""
                        width={78}
                        height={78}
                        unoptimized
                        className="absolute inset-0 opacity-90"
                    />
                )}
                <Image
                    src={skin.icon + '/86fx86'}
                    alt={skin.name}
                    width={78}
                    height={78}
                    className="relative object-contain"
                    style={{ filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.35))' }}
                />
            </div>
            <div className="text-[11px] text-text_3 text-center truncate w-full">
                {skin.name}
            </div>
            <div className="font-chat-nick text-[12.5px] font-extrabold text-accent_5 tabular-nums">
                ${skin.priceUsd.toFixed(2)}
            </div>
            <span
                aria-hidden
                className="absolute bottom-0 inset-x-0 h-[2.5px]"
                style={{ background: `linear-gradient(90deg, transparent, ${rarity}, transparent)` }}
            />
        </div>
    );
};

export default CaseSkin;
